import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
export const OfferSection = () => {
  const items = [{
    title: 'Ebook Principal',
    description: 'Tu hoja de ruta para reprogramar tu metabolismo',
    value: '$197'
  }, {
    title: 'Guía de Suplementos Bio-idénticos',
    description: 'Qué tomar para sofocos, lívido y densidad ósea',
    value: '$97'
  }, {
    title: 'Protocolo "SOS Resaca Hormonal"',
    description: 'Recuperación rápida tras un día de excesos o estrés',
    value: '$67'
  }, {
    title: 'El Recetario de 15 Minutos',
    description: 'Comidas rápidas que no disparan la insulina',
    value: '$47'
  }, {
    title: 'Manual: El Santuario del Sueño',
    description: 'Guía táctica para eliminar el insomnio de las 3 AM',
    value: '$47'
  }, {
    title: 'Checklist: Compras de Supermercado 40+',
    description: 'Qué comprar exactamente y qué marcas evitar',
    value: '$27'
  }, {
    title: 'Rutinas de Fuerza en Casa (Sin Equipo)',
    description: 'Tonifica y protege el músculo sin elevar cortisol',
    value: '$37'
  }, {
    title: 'El Diario de Bio-Feedback Hormonal',
    description: 'Identifica tus disparadores de inflamación únicos',
    value: '$27'
  }, {
    title: 'El Método de Ventanas Circadianas',
    description: 'Guía de alimentación según tu reloj biológico',
    value: '$47'
  }, {
    title: 'Guía: Alcohol, Café y Hormonas',
    description: 'Cómo disfrutarlos sin arruinar tu progreso',
    value: '$27'
  }, {
    title: 'El Protocolo "Focus Laser"',
    description: 'Nutrición y hábitos contra la neblina mental',
    value: '$47'
  }, {
    title: 'Guía de Despensa Libre de Tóxicos',
    description: 'Elimina disruptores endocrinos de tu cocina',
    value: '$27'
  }, {
    title: 'Plan de 7 Días de Desinflamación Express',
    description: 'El "reset" rápido para ocasiones especiales',
    value: '$37'
  }, {
    title: 'Manual de Gestión de Estrés Invisible',
    description: 'Técnicas físicas para calmar el sistema nervioso',
    value: '$27'
  }, {
    title: 'Herbolaria Hormonal: Té e Infusiones',
    description: 'Guía terapéutica de hierbas para mujeres 40+',
    value: '$17'
  }, {
    title: 'Hoja de Ruta: De los 40 a los 60',
    description: 'Qué esperar y cómo ajustar el plan cada década',
    value: '$17'
  }];
  return <section id="bonuses" className="py-8 px-4 md:px-8 bg-white" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-135">
          <h2 className="text-sm font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-136">
            Presentamos
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-brand-green mb-4" data-id="element-137">
            EL CÓDIGO HORMONAL +40
          </h3>
          <p className="text-xl text-brand-charcoal/80 font-serif italic" data-id="element-138">
            El sistema completo que te guía de la mano por tu transición
            hormonal.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-139">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1 lg:sticky lg:top-24" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/3To3fFMjn2GzTqG8jFE8Ff/Imagen_Producto.png" alt="El Código Hormonal +40 Bundle" className="w-full max-w-md mx-auto drop-shadow-xl" data-id="element-141" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2 bg-brand-cream p-6 md:p-8 rounded-3xl shadow-sm border border-brand-gold/20" data-id="element-142">
            <h4 className="text-2xl font-serif font-bold text-brand-charcoal mb-6 border-b border-brand-gold/30 pb-4" data-id="element-143">
              Lo que obtienes hoy:
            </h4>

            <ul className="space-y-3 mb-8" data-id="element-144">
              {items.map((item, index) => <li key={index} className="flex items-start gap-3 py-2 border-b border-brand-creamAlt/80 last:border-0" data-id="element-145">
                  <div className="mt-1 bg-brand-green/10 p-1 rounded-full text-brand-green flex-shrink-0" data-id="element-146">
                    <CheckIcon className="w-4 h-4" data-id="element-147" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-148">
                    <div className="flex items-baseline justify-between gap-2" data-id="element-149">
                      <span className="text-brand-charcoal font-semibold text-sm md:text-base" data-id="element-150">
                        {index === 0 ? '' : `${index}. `}
                        {item.title}
                      </span>
                      <span className="text-sm font-bold text-brand-green whitespace-nowrap" data-id="element-151">
                        {item.value}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-brand-charcoal/60 mt-0.5" data-id="element-152">
                      {item.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="bg-white p-5 rounded-xl text-center border-2 border-brand-gold/30" data-id="element-153">
              <p className="text-sm text-brand-charcoal/60 uppercase tracking-widest mb-1" data-id="element-154">
                Valor Total del Paquete
              </p>
              <p className="text-4xl font-bold text-brand-crimson line-through decoration-2 opacity-70" data-id="element-155">
                $643
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};